import React from 'react';
import ReactHtmlParser from 'react-html-parser';

const DestacadoIzquierda = ({ componente }) => {

    const iconoStyles = Object.assign(
        {
            backgroundImage: `url(${process.env.REACT_APP_BASE_URL_API}/${componente.image_file.filename})`
        },
        JSON.parse(componente.image_file.styles)
    );


    const background = {
        color: {
            backgroundColor: componente.page_background.color_hex
        },
        image: {
            backgroundImage: componente.page_background.image_file && `url(${process.env.REACT_APP_BASE_URL_API}/${componente.page_background.image_file.filename})`
        }
    };

    return (
        <a href={componente.url ? componente.url : null} className="card-link" target="_self" rel="noopener noreferrer">
            <div className="card bg-card shadow-none mt-4"
                style={
                    background[componente.page_background.type]
                }
            >
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            {ReactHtmlParser(componente.title ? componente.title.replace(/!important/g, "") : '')}
                        </div>
                        <div className="col-4">
                        <div className="d-flex align-items-center">
                            <div className="icono-home-xl" style={iconoStyles}/>
                        </div>
                        </div>
                        <div className="col-8">
                            {ReactHtmlParser(componente.copete ? componente.copete.replace(/!important/g, "") : '')}
                        </div>
                    </div>
                </div>
            </div>
        </a>
    );
};

export default DestacadoIzquierda;
